import axios from 'axios';
import authHeader from './auth-header';
import Jsona from "jsona";

const API_URL = process.env.VUE_APP_API_BASE_URL;
const dataFormatter = new Jsona();

export default {
    async getUnetworks(params) {
        const response = await axios.get(API_URL + "/unetworks", { headers: authHeader(), params: params });
        return { data: dataFormatter.deserialize(response.data), meta: response.data.meta?.page };
    },

    async addUnetwork(unetwork) {
        unetwork.type = "unetworks"
        const newJson = dataFormatter.serialize({ stuff: unetwork })
        const response = await axios.post(API_URL + "/unetworks", newJson, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },

    async deleteUnetwork(unetworkId) {
        await axios.delete(API_URL + "/unetworks/" + unetworkId, { headers: authHeader() });
    },

    async getUnetwork(unetworkId) {
        const response = await axios.get(API_URL + "/unetworks/" + unetworkId, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },

    async editUnetwork(unetwork) {
        unetwork.type = "unetworks"
        const newJson = dataFormatter.serialize({ stuff: unetwork })
        const response = await axios.patch(API_URL + "/unetworks/" + unetwork.id, newJson, { headers: authHeader() });
        return dataFormatter.deserialize(response.data);
    },
}




